import { render, staticRenderFns } from "./rmIpfr.vue?vue&type=template&id=38e69281"
import script from "./rmIpfr.vue?vue&type=script&lang=js"
export * from "./rmIpfr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports